/*
  Life InStyle — the Flexiti 3 / 6 / 12-month boxes under the product price.

  Each box is a <button aria-pressed> (sections/instyle-product.liquid).
  Tapping a box selects it and shows the "Apply with Flexiti" button beneath
  the boxes; tapping another box moves the selection; tapping the selected box
  again clears it and hides the button (Naman, 2026-10-20: after the first
  pass the boxes looked the same whether chosen or not).

  Dawn's product-info.js re-draws the whole price block whenever a size is
  chosen, which would drop the selection, so the chosen term is remembered
  here and put back on the new boxes.
*/
(function () {
  if (window.instyleFlexitiApply) return;
  window.instyleFlexitiApply = true;

  var selectedTerm = null;

  function show(box, term) {
    var tiles = box.querySelectorAll('[data-flexiti-term]');
    var any = false;
    tiles.forEach(function (tile) {
      var on = term !== null && tile.getAttribute('data-flexiti-term') === term;
      tile.setAttribute('aria-pressed', on ? 'true' : 'false');
      tile.classList.toggle('is-selected', on);
      if (on) any = true;
    });
    var apply = box.querySelector('.instyle-pdp__monthly-apply');
    if (apply) apply.hidden = !any;
  }

  function restore() {
    document.querySelectorAll('[data-flexiti-apply]').forEach(function (box) {
      show(box, selectedTerm);
    });
  }

  document.addEventListener('click', function (e) {
    var tile = e.target && e.target.closest ? e.target.closest('[data-flexiti-term]') : null;
    if (!tile) return;
    var box = tile.closest('[data-flexiti-apply]');
    if (!box) return;
    var term = tile.getAttribute('data-flexiti-term');
    selectedTerm = tile.getAttribute('aria-pressed') === 'true' ? null : term;
    show(box, selectedTerm);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    // Published after the new price has been put in place.
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      if (selectedTerm !== null) restore();
    });
  }
})();
